<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div> 移动班级</div>
                <div @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask-content-body-select">
                    <div class="mask-content-body-select-title">分组名称<span>*</span>：</div>
                    <div class="mask-content-body-select-input">
                        <el-select v-model="group_id" placeholder="请选择" disabled popper-class="groupselsect"
                            popper-append-to-body>
                            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="mask-content-body-select">
                    <div class="mask-content-body-select-title">分组名称<span>*</span>：</div>
                    <div class="mask-content-body-select-input">
                        <el-select v-model="form.newgroup_id" placeholder="请选择" popper-class="groupselsect"
                            popper-append-to-body>
                            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund">取消</div>
                    <div @click="handleSubmit">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddGroup",
    props: ['dataVal'],
    data() {
        return {
            options: [],

            group_id: '',
            activity_id: '',
            form: {
                banji_id: '',
                newgroup_id: ''
            }
        };
    },
    mounted() {
    },
    methods: {
        async activityGrouplist() {
            let res = await this.$api.activityGrouplist({
                activity_id: this.activity_id
            })
            if (res.code == 1) {
                this.options = res.data
            }
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("mobileClassCall", data);
        },
        handleSubmit() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                form: this.form
            }
            this.$emit("mobileClassCall", data);
        },
    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                if (newVal.flag) {
                    this.group_id = newVal.data.group_id ? newVal.data.group_id : ''
                    this.activity_id = newVal.data.activity_id
                    this.activityGrouplist()

                    this.form = {
                        banji_id: newVal.data.banji_id,
                        newgroup_id: ''
                    }
                }
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 715px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
            }
        }

        .mask-content-body {
            width: 100%;
            background-color: #FFF;
            padding: 20px 20px 34px 20px;

            .mask-content-body-select {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .mask-content-body-select-title {
                    width: 87px;
                    color: #A6A6A6;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    span {
                        color: #C12E30;
                    }
                }

                .mask-content-body-select-input {
                    flex: 1;

                    .el-select {
                        width: 100%;
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 45px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}
</style>